export default __webpack_public_path__ + "static/media/MEXC-logo.c6ff91c6.svg";